import React from "react";
import "../Styles/Footer.css";

const Footer: React.FC = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-container">
        <div className="footer-top">
          <div className="brand-section">
            <div className="logo">DigiRay</div>
            <p className="tagline">Precision diagnostics through advanced imaging</p>

            <div className="social-icons" aria-label="Social links">
              <a href="#" aria-label="Twitter" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M23 3c-.9.6-1.9.9-3 .9.9-.6 1.6-1.7 1.9-2.9-.9.5-2 .8-3.1 1C17.6 1 16.1.6 14.5.9c-1.6.4-2.9 1.7-3.4 3.2-2.9.2-5.2-1.4-6.9-3.4C-1 6 8 11 12 11c-1.2.9-2.7 1.4-4.3 1.4-.4 0-.8 0-1.2-.1 1.3 2 3.9 3.3 6.6 3.4-3.9 2.9-8.7 3.8-13.1 2.8C3.9 21.4 8.8 23 14 23c8 0 12-7 12-13 0-.2 0-.4 0-.6.8-.6 1.6-1.4 2.2-2.3-.7.4-1.5.6-2.3.7z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>

              <a href="#" aria-label="LinkedIn" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M16 8c1.6 0 3.1.6 4.2 1.7C21.4 10.8 22 12.3 22 14v7h-4v-7c0-.5-.2-1-.4-1.4-.3-.4-.8-.6-1.3-.6-.6 0-1.1.2-1.5.6-.3.4-.5.9-.5 1.4v6.9h-4V8h4v1.7c.3-.4.9-.7 1.5-.7z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6 9H2v12h4zM4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>

              <a href="#" aria-label="Facebook" className="social-link">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M18 2h-3c-1.3 0-2.6.5-3.6 1.4C9.3 4.3 9 5.7 9 7.1V10H6v4h3v10h4V14h3l1-4h-4V7.4c0-.2.1-.4.3-.6.2-.2.4-.3.7-.3H18V2z" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="links-section" aria-label="Footer navigation">
            <div className="footer-column">
              <h4>Company</h4>
              <ul>
                <li><a href="#">About</a></li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="#">Press</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Resources</h4>
              <ul>
                <li><a href="#">Help Center</a></li>
                <li><a href="#">Partners</a></li>
                <li><a href="#">Community</a></li>
                <li><a href="#">Events</a></li>
              </ul>
            </div>

            <div className="footer-column">
              <h4>Legal</h4>
              <ul>
                <li><a href="#">Privacy</a></li>
                <li><a href="#">Terms</a></li>
                <li><a href="#">Cookies</a></li>
                <li><a href="#">Disclaimer</a></li>
              </ul>
            </div>
          </div>

          <div className="subscribe-section" aria-label="Subscribe">
            <h4>Stay up-to-date</h4>
            <p>Subscribe for product updates, research and case studies.</p>

            <form className="subscribe-form" onSubmit={(e) => e.preventDefault()}>
              <input
                type="email"
                placeholder="Enter your email"
                aria-label="Email address"
                required
              />
              <button type="submit" aria-label="Subscribe">
                <span>Subscribe</span>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
                  <path d="M5 12h14M19 12l-6-6M19 12l-6 6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </form>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="copyright">© {new Date().getFullYear()} DigiRay. All rights reserved.</div>
          <div className="legal-links" aria-hidden>
            <a href="#">Privacy</a>
            <a href="#">Terms</a>
            <a href="#">Cookies</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
